'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dAbstract$002dComponent from "./mealorama.components.-Abstract-Component.js";
import * as $j_mealorama$002epages$002e$002dTesting$002dPage$0024$002dBackend from "./mealorama.pages.-Testing-Page$-Backend.js";
import * as $j_mealorama$002epages$002e$002dTesting$002dPage$0024$002dState from "./mealorama.pages.-Testing-Page$-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_TestingPage$() {
  this.aoP = null;
  $n_Lmealorama_pages_TestingPage$ = this;
  $j_mealorama$002ecomponents$002e$002dAbstract$002dComponent.$f_Lmealorama_components_AbstractComponent__$init$__V(this);
  this.aoP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().kx("TestingPage", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $j_mealorama$002epages$002e$002dTesting$002dPage$0024$002dState.$c_Lmealorama_pages_TestingPage$State($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$())))).gJ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => new $j_mealorama$002epages$002e$002dTesting$002dPage$0024$002dBackend.$c_Lmealorama_pages_TestingPage$Backend(_$5$2)))).od(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$6$2, _$7$2) => _$6$2.cA().b04(_$7$2)))).gj($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_CtorType$Summoner$().qQ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_internal_Singleton$().on));
}
export { $c_Lmealorama_pages_TestingPage$ as $c_Lmealorama_pages_TestingPage$ };
$p = $c_Lmealorama_pages_TestingPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_TestingPage$;
/** @constructor */
function $h_Lmealorama_pages_TestingPage$() {
}
export { $h_Lmealorama_pages_TestingPage$ as $h_Lmealorama_pages_TestingPage$ };
$h_Lmealorama_pages_TestingPage$.prototype = $p;
$p.jI = (function(x$0) {
});
$p.jK = (function(x$0) {
});
$p.jJ = (function(x$0) {
});
$p.qs = (function() {
  return this.aoP.eh().C();
});
var $d_Lmealorama_pages_TestingPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_TestingPage$, "mealorama.pages.TestingPage$", ({
  Lz: 1,
  ai: 1,
  aL: 1
}));
export { $d_Lmealorama_pages_TestingPage$ as $d_Lmealorama_pages_TestingPage$ };
var $n_Lmealorama_pages_TestingPage$;
function $m_Lmealorama_pages_TestingPage$() {
  if ((!$n_Lmealorama_pages_TestingPage$)) {
    $n_Lmealorama_pages_TestingPage$ = new $c_Lmealorama_pages_TestingPage$();
  }
  return $n_Lmealorama_pages_TestingPage$;
}
export { $m_Lmealorama_pages_TestingPage$ as $m_Lmealorama_pages_TestingPage$ };
//# sourceMappingURL=mealorama.pages.-Testing-Page$.js.map
